var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useMemo } from 'react';
import InformationColumn from './micros/InformationColumn/Index';
import ListFeaturesColumn from './micros/ListFeaturesColumn/Index';
import runAndCreateTimeline from './animations/index';
// import { sampleData } from '../../components/HoverNumberedList/data';
import './HoverNumberedList.scss';
var sampleData = {
    background_type: 'blue',
    tabList: [
        {
            listText: 'Data Intelligence',
            mainTitleText: {
                value: 'category 1 headline',
            },
            listFeaturesArray: [
                {
                    title: "Financial Professionals",
                    order: 1,
                    content: "Supercharge your practice\u2019s growth while making financial wellness possible for your clients.",
                    href: '/why-envestnet-live-text',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
            ],
        },
        {
            listText: 'Analytics & Insights',
            mainTitleText: {
                value: 'category 2 headline',
            },
            listFeaturesArray: [
                {
                    title: "Financial Professionals2",
                    order: 1,
                    content: "Supercharge your practice\u2019s growth while making financial wellness possible for your clients.",
                    href: '/why-envestnet-live-text',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
            ],
        },
        {
            listText: 'Embedded Experiences',
            mainTitleText: {
                value: 'category 2 headline',
            },
            listFeaturesArray: [
                {
                    title: "Financial Professionals2",
                    order: 1,
                    content: "Supercharge your practice\u2019s growth while making financial wellness possible for your clients.",
                    href: '/why-envestnet-live-text',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
                {
                    title: "Broker-Dealer Home Offices",
                    order: 2,
                    content: "Empower participants in the planning process with goal-based strategies and interactive engagement tools to help make their dreams a reality.",
                    href: 'https://jsonlint.com/',
                },
            ],
        },
    ],
};
export var HoverTextListWithTab = function (_a) {
    var _b;
    var _c = _a.data, data = _c === void 0 ? sampleData : _c, background = _a.background;
    // console.log(data, background, 'data');
    var mainTitleText = (_b = data === null || data === void 0 ? void 0 : data.mainTitleText) === null || _b === void 0 ? void 0 : _b.value;
    var withAnimation = (data === null || data === void 0 ? void 0 : data.withAnimation) || true;
    var listFeaturesArray = data && data.listFeaturesArray;
    var _d = useState(null), activeContentInformation = _d[0], setActiveContentInformation = _d[1];
    var _e = useState(null), itemActiveFromMobile = _e[0], setActivationFromMobile = _e[1];
    var _f = useState(false), isFirstTimelineCompleted = _f[0], setIsFirstTimelineCompleted = _f[1];
    var isFunctionallityReady = useMemo(function () { return !withAnimation || isFirstTimelineCompleted; }, [isFirstTimelineCompleted, withAnimation]);
    var rightColumnRef = useRef(null);
    var leftTextColumnRef = useRef(null);
    var mainElementTriggerRef = useRef(null);
    var leftColumnRef = useRef(null);
    var handleActiveContentInformation = function (newStateValue) {
        if (isFunctionallityReady) {
            setActiveContentInformation(newStateValue);
        }
    };
    var handleActiveFromMobile = function (newStateValue) {
        setActivationFromMobile(newStateValue);
    };
    useEffect(function () {
        setActivationFromMobile(null);
    }, [data]);
    useEffect(function () {
        if (withAnimation) {
            runAndCreateTimeline({
                rightColumnRef: rightColumnRef,
                mainElementTriggerRef: mainElementTriggerRef,
                leftTextColumnRef: leftTextColumnRef,
                setIsFirstTimelineCompleted: setIsFirstTimelineCompleted,
            });
        }
    }, []);
    return (_jsx("div", __assign({ className: "hover-text-list-tabs" }, { children: _jsx("div", __assign({ className: "jobs relative snap-start", ref: mainElementTriggerRef, style: { paddingTop: '0px' } }, { children: _jsxs("div", __assign({ className: "justify-center px-6 md:px-20 lg:flex lg:px-0" }, { children: [_jsx(InformationColumn, { setActivationFromMobile: handleActiveFromMobile, itemActiveFromMobile: itemActiveFromMobile, mainTitleText: mainTitleText, nativeLeftTitleRef: leftTextColumnRef, nativeLeftColumnRef: leftColumnRef, activeContentItem: activeContentInformation, background: background }, void 0),
                    _jsx(ListFeaturesColumn, { nativeMainRef: rightColumnRef, setActivationFromMobile: handleActiveFromMobile, itemActiveFromMobile: itemActiveFromMobile, activeContentInformation: activeContentInformation, listFeaturesArray: listFeaturesArray, setActiveContentInformation: handleActiveContentInformation, background: background }, void 0)] }), void 0) }), void 0) }), void 0));
};
